import { render } from "./DarkBasicTemplate.vue?vue&type=template&id=5f344208&scoped=true"
import script from "./DarkBasicTemplate.vue?vue&type=script&lang=js"
export * from "./DarkBasicTemplate.vue?vue&type=script&lang=js"

import "./DarkBasicTemplate.vue?vue&type=style&index=0&id=5f344208&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f344208"]])

export default __exports__